<template>
    <section>
        <div class="section-table">
            <pagination
                class="pagination-top"
                :total="zaps.total"
                :page.sync="zaps.current_page"
                :limit.sync="zaps.per_page"
                @pagination="setLogData(false)"
                :page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
            >
                <el-input
                    style="margin-left: 10px"
                    size="small"
                    v-model="search"
                    placeholder="Search Ambition Zaps by Name"
                ></el-input>
                <el-button
                    style="margin-left: 10px"
                    size="small"
                    class="new-template"
                    type="primary"
                    @click="openZapModal(false)"
                >
                    Create Zap
                </el-button>
            </pagination>

            <el-table
                ref="zapTable"
                v-loading="tableLoading"
                :data="tableData"
                stripe
                style="width: 100%"
                :row-key="setRowKeys"
                :default-sort="{ prop: 'updated_at', order: 'descending' }"
            >
                <el-table-column prop="name" sortable label="Name" width="250"></el-table-column>

                <el-table-column prop="endpoint" sortable label="Webhook URL"></el-table-column>

                <el-table-column prop="triggers" sortable label="Triggers">
                    <template slot-scope="scope">
                        {{ triggerFormatter(scope.row.triggers) }}
                    </template>
                </el-table-column>

                <el-table-column prop="fieldsCount" sortable label="Data Fields" width="130"></el-table-column>

                <el-table-column prop="zapCount" sortable label="Zap Count" width="130"></el-table-column>

                <el-table-column
                    fixed="right"
                    sortable
                    prop="updated_at"
                    label="Last Updated"
                    width="200"
                    :formatter="dateFormatter"
                ></el-table-column>

                <el-table-column fixed="right" label="Action" width="200">
                    <template slot-scope="scope">
                        <el-button :disabled="visible" @click="openZapModal(scope.row)" style="color: blue" type="text">
                            Edit
                        </el-button>
                        <el-button :disabled="activeClicked" @click="setActiveState(scope.row)" type="text">
                            <span v-if="scope.row.active" style="color: orange">Disable</span>
                            <span v-else style="color: green">Activate</span>
                        </el-button>
                        <el-button :disabled="deleteClicked" @click="deleteZap(scope.row)" style="color: red"
                                   type="text">
                            Delete
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <pagination
                class="pagination-bottom"
                :total="zaps.total"
                :page.sync="zaps.current_page"
                :limit.sync="zaps.per_page"
                @pagination="setLogData(false)"
                :page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
            >
                <el-input
                    style="margin-left: 10px"
                    size="small"
                    v-model="search"
                    placeholder="Search Ambition Zaps by Name"
                ></el-input>
                <el-button
                    style="margin-left: 10px"
                    size="small"
                    class="new-template"
                    type="primary"
                    @click="openZapModal(false)"
                >
                    Create Zap
                </el-button>
            </pagination>
        </div>

        <x-modal
            :wWidth="960"
            v-if="visible"
            @cancel="visible = false"
            @close="visible = false"
            @ok="saveZap(create ? true : false)"
            @okSecondary="saveZap(true)"
            :draggable="true"
            :resizable="true"
            :loading="loading"
            :okDisabled="loading"
            :okSecondaryDisabled="loading"
            :okText="create ? 'Save and Test Zap' : 'Update'"
            okSecondaryText="Update and Test Zap"
            :hideOkSecondary="create ? true : false"
        >
            <div slot="title" :class="`d-flex justify-content-between align-items-center`">
                {{ this.create ? "Create" : "Update" }} Zap Integration
            </div>

            <el-form ref="zapForm" :model="zapForm" :rules="rules" label-width="150">
                <el-form-item label="Name" prop="name">
                    <small>To make it easier to manage, enter the same name you set in Zapier</small>
                    <el-input v-model="zapForm.name" placeholder=""></el-input>
                </el-form-item>

                <el-form-item label="Webhook URL" prop="endpoint">
                    <small>Enter the Webook URL that was generated from Zapier.</small>
                    <el-input v-model="zapForm.endpoint" placeholder=""></el-input>
                </el-form-item>

                <el-form-item label="Partner Zap" prop="partner_zap">
                    <small>Is this zap for an external partner?.</small>
                    <el-switch v-model="zapForm.partner_zap" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>

                <el-form-item label="Zap Trigger" prop="triggers">
                    <small>Select the stage/s this zap will trigger at</small>
                    <el-select multiple filterable style="width: 100%" v-model="zapForm.triggers" placeholder="">
                        <el-option-group v-for="group in statusList" :key="group.label" :label="group.label">
                            <el-option
                                v-for="item in group.options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-option-group>
                    </el-select>
                </el-form-item>

                <el-form-item label="Zap Data" prop="fields">
                    <small>Select the data you wish to send to Zapier</small>

                    <el-transfer
                        class="w-100"
                        v-model="zapForm.fields"
                        :data="zapData"
                        :titles="['Available Data', 'Data being sent to Zapier']"
                        :button-texts="['Remove', 'Send to Zapier']"
                    ></el-transfer>
                </el-form-item>

                <el-row :gutter="20">
                    <el-col :span="12" :offset="0">
                        <el-form-item label="Application Type" prop="application_type_id">
                            <small>Choose to send this zap if the application type matches (leave empty to match
                                any)</small>
                            <el-select class="w-100" v-model="zapForm.application_type_id" placeholder="Any" clearable>
                                <el-option label="Consumer" :value="1"></el-option>
                                <el-option label="Commercial" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :offset="0">
                        <el-form-item label="Teams" prop="teams">
                            <small>Choose to send this zap if the teams matches (leave empty to match any)</small>
                            <el-select class="w-100" v-model="zapForm.teams" placeholder="Any" multiple clearable>
                                <el-option
                                    v-for="team in userTeams"
                                    :key="team.id"
                                    :label="team.name"
                                    :value="team.id"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :offset="0">
                        <el-form-item label="Review Requested" prop="review_requested">
                            <small>
                                Choose to send this zap if a review has been requested or not (leave empty to match any)
                            </small>
                            <el-select class="w-100" v-model="zapForm.review_requested" placeholder="Any" clearable>
                                <el-option label="Yes" :value="1"></el-option>
                                <el-option label="No" :value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" :offset="0">
                        <el-form-item label="Repeat Zap" prop="repeat">
                            <small>
                                Choose to repeat the zap if the stage is triggered again or only send it once per zap
                                trigger
                            </small>
                            <el-select class="w-100" v-model="zapForm.repeat" placeholder="">
                                <el-option label="Yes" :value="1"></el-option>
                                <el-option label="No" :value="0"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </x-modal>
    </section>
</template>

<script>
import {mapGetters} from "vuex"
import Pagination from "@shared/components/pagination"

export default {
    name: "ZapsTable",
    components: {
        Pagination,
    },
    props: {
        options: {
            required: true,
        },
    },
    computed: {
        ...mapGetters({
            zaps: "zapier/getZaps",
            logs: "zapier/getLogs",
            customFields: "zapier/getCustomFields",
            user: "user/user",
        }),
        closeReasons() {
            if (_.isEmpty(this.options.closeReasons)) return []
            return this.options.closeReasons.map((reason) => {
                return {
                    label: reason.name,
                    value: `close-${reason.id}`,
                }
            })
        },
        userTeams() {
            var userTeams = _.get(Ambition.Globals, "tenant.user.teams", [])

            if (!userTeams.length && Ambition.hasRoleOrPermission(["administrator"])) {
                return _.get(Ambition.Globals, "tenant.teams", [])
            }

            return _.get(Ambition.Globals, "tenant.user.teams", [])
        },
        statusList() {
            return [
                {
                    label: "Events",
                    options: [
                        {
                            label: "New Lead",
                            value: "event-0",
                        },
                        {
                            label: "1 Hour Contact Check",
                            value: "event-1",
                        },
                        {
                            label: "Assign Externally",
                            value: "event-2",
                        },
                    ],
                },
                {
                    label: "Stage Change",
                    options: [
                        {
                            label: "Application New",
                            value: "stage-1",
                        },
                        {
                            label: "Application Taken",
                            value: "stage-2",
                        },
                        {
                            label: "Documents Received",
                            value: "stage-3",
                        },
                        {
                            label: "Submitted to Lender",
                            value: "stage-4",
                        },
                        {
                            label: "Conditionally Approved",
                            value: "stage-5",
                        },
                        {
                            label: "Invoice Requested",
                            value: "stage-6",
                        },
                        {
                            label: "Invoice Returned",
                            value: "stage-7",
                        },
                        {
                            label: "Loan Package Sent",
                            value: "stage-8",
                        },
                        {
                            label: "Loan Package Confirmed",
                            value: "stage-9",
                        },
                        {
                            label: "Loan Submitted",
                            value: "stage-10",
                        },
                        {
                            label: "Loan Approved",
                            value: "stage-11",
                        },
                        {
                            label: "Contracts Sent",
                            value: "stage-12",
                        },
                        {
                            label: "In for Settlement",
                            value: "stage-13",
                        },
                        {
                            label: "Settled",
                            value: "stage-14",
                        },
                        {
                            label: "Completed",
                            value: "stage-15",
                        },
                    ],
                },
                {
                    label: "Close Reason",
                    options: this.closeReasons,
                },
            ]
        },
        tableData() {
            // check to see if the required data is loaded
            if (_.isEmpty(this.zaps.data) && _.isEmpty(this.user)) return []
            return this.zaps.data
        },

        zapData() {
            const data = []
            this.zapOptions.forEach((option) => {
                data.push({
                    key: option.key,
                    value: option.key,
                    label: option.label,
                    disabled: true,
                })
                option.options.forEach((optionData) => {
                    data.push({
                        key: optionData.value,
                        value: optionData.value,
                        label: optionData.label,
                        disabled: false,
                    })
                })
            })
            return data
        },
    },
    data() {
        return {
            value: [],
            create: true,
            loading: false,
            deleteClicked: false,
            activeClicked: false,
            tableLoading: true,
            search: "",
            searchTimeout: null,
            searchTimeoutWait: 1000,
            visible: false,
            zapForm: {
                active: 0,
                repeat: 0,
                team_id: _.get(window.TenantGlobals, 'currentTeamId')
            },
            rules: {
                name: [{required: true, message: "Name is Required", trigger: "blur"}],
                endpoint: [{required: true, pattern:/^(https:\/\/hooks\.zapier\.com|https:\/\/hook\..*\.make\.com)/, message: 'Please input either a Zapier webhook or a Make.com webhook', trigger: 'blur' }],
                triggers: [{required: true, message: "Zap Trigger is Required", trigger: "change"}],
                fields: [{required: true, message: "Zap Data is Required", trigger: "change"}],
                repeat: [{required: true, message: "Subject is Required", trigger: "change"}],
            },
            headers: {
                headers: {
                    Authorization: "Bearer " + this.$store.getters.token,
                },
            },
            zapOptions: [
                {
                    key: "application_data",
                    label: "Application",
                    options: [
                        {
                            value: "application/campaign.source.name",
                            label: "Lead Source",
                        },
                        {
                            value: "application/campaign.sourceDetail.name",
                            label: "Lead Source Detail",
                        },
                        {
                            value: "application/id",
                            label: "Application ID",
                        },
                        {
                            value: "application/ref",
                            label: "Application Reference ID",
                        },
                        {
                            value: "application/status.name",
                            label: "Application Status",
                        },
                        {
                            value: "application/stage.name",
                            label: "Current Stage",
                        },
                        {
                            value: "application/loan.type.name",
                            label: "Loan Type",
                        },
                        {
                            value: "application/loan.product.type.name",
                            label: "Product Type",
                        },
                        {
                            value: "application/team.name",
                            label: "Team",
                        },
                        {
                            value: "application/closeReason",
                            label: "Close Reason",
                        },
                        {
                            value: "application/customerReview.sendReviewRequest",
                            label: "Review Request Sent",
                        },
                        {
                            value: "application/customerReview.noReviewRequestReason",
                            label: "No Review Request Reason",
                        },
                        {
                            value: "application/commission.dof",
                            label: "DOF",
                        },
                        {
                            value: "application/commission.finance",
                            label: "Finance Commission",
                        },
                        {
                            value: "application/commission.insurances",
                            label: "Insurance Commission",
                        },
                        {
                            value: "application/commission.total",
                            label: "Total Commission",
                        },
                        {
                            value: "application/amount_to_financed",
                            label: "Amount To Finance",
                        }
                    ],
                },
                {
                    key: "campaign_data",
                    label: "Campaign",
                    options: [
                        {
                            value: "application/campaign.name",
                            label: "Campaign Name",
                        },
                        {
                            value: "application/campaign.medium",
                            label: "Campaign Medium",
                        },
                        {
                            value: "application/campaign.content",
                            label: "Campaign Content",
                        },
                        {
                            value: "application/campaign.term",
                            label: "Campaign Term",
                        },
                        {
                            value: "application/campaign.gclid",
                            label: "Campaign GCLID",
                        },
                        {
                            value: "application/campaign.gbraid",
                            label: "Campaign GBRAID",
                        },
                        {
                            value: "application/campaign.adsetname",
                            label: "Campaign ADSETNAME",
                        },
                        {
                            value: "application/campaign.adname",
                            label: "Campaign ADNMAE",
                        },
                        {
                            value: "application/campaign.placement",
                            label: "Campaign PLACEMENT",
                        },
                        {
                            value: "application/campaign.keyword",
                            label: "Campaign KEYWORD",
                        },
                        {
                            value: "application/campaign.matchtype",
                            label: "Campaign MATCHTYPE",
                        },
                        {
                            value: "application/campaign.device",
                            label: "Campaign Device",
                        },
                        {
                            value: "application/campaign.source_name",
                            label: "Campaign Source",
                        }
                    ],
                },
                {
                    key: "settlement_data",
                    label: "Settlement",
                    options: [
                        {
                            value: "settlement/settlement.remittanceDate",
                            label: "Remittance Date",
                        },
                        {
                            value: "settlement/settlement.completedDate",
                            label: "Completed Date",
                        },
                    ],
                },
                {
                    key: "finance_data",
                    label: "Finance",
                    options: [
                        {
                            value: "finance/loan.finance.amount",
                            label: "Finance Amount",
                        },
                        {
                            value: "finance/loan.finance.monthlyRepayment",
                            label: "Monthly Repayment",
                        },
                        {
                            value: "finance/loan.finance.term",
                            label: "Term",
                        },
                        {
                            value: "finance/loan.package.writingRate",
                            label: "Writing Rate",
                        },
                        {
                            value: "finance/loan.finance.termEndDate",
                            label: "Term End Date",
                        },
                        {
                            value: "finance/loan.finance.fees.establishment",
                            label: "Establishment Fees",
                        },
                        {
                            value: "finance/loan.finance.fees.monthly",
                            label: "Monthly Fees",
                        },
                    ],
                },
                {
                    key: "applicant_data",
                    label: "Applicants",
                    options: [
                        {
                            value: "applicants/applicant.title",
                            label: "Applicant Title",
                        },
                        {
                            value: "applicants/applicant.fullName",
                            label: "Applicant Full Name",
                        },
                        {
                            value: "applicants/applicant.firstName",
                            label: "Applicant First Name",
                        },
                        {
                            value: "applicants/applicant.lastName",
                            label: "Applicant Last Name",
                        },
                        {
                            value: "applicants/applicant.email",
                            label: "Applicant Email",
                        },
                        {
                            value: "applicants/applicant.dateOfBirth",
                            label: "Applicant Date of Birth",
                        },
                        {
                            value: "applicants/applicant.gender",
                            label: "Applicant Gender",
                        },
                        {
                            value: "applicants/applicant.address.full",
                            label: "Applicant Full Address",
                        },
                        {
                            value: "applicants/applicant.address.unitNumber",
                            label: "Applicant Address - Unit Number",
                        },
                        {
                            value: "applicants/applicant.address.streetNumber",
                            label: "Applicant Address - Street Number",
                        },
                        {
                            value: "applicants/applicant.address.streetName",
                            label: "Applicant Address - Street Name",
                        },
                        {
                            value: "applicants/applicant.address.suburb",
                            label: "Applicant Address - Suburb",
                        },
                        {
                            value: "applicants/applicant.address.city",
                            label: "Applicant Address - City",
                        },
                        {
                            value: "applicants/applicant.address.state",
                            label: "Applicant Address - State",
                        },
                        {
                            value: "applicants/applicant.address.postcode",
                            label: "Applicant Address - Postcode",
                        },
                        {
                            value: "applicants/applicant.address.country",
                            label: "Applicant Address - Country",
                        },
                        {
                            value: "applicants/applicant.address.propertyStatus",
                            label: "Applicant Property Status",
                        },
                        {
                            value: "applicants/applicant.mobile",
                            label: "Applicant Mobile Phone",
                        },
                        {
                            value: "applicants/applicant.homePhone",
                            label: "Applicant Home Phone",
                        },
                        {
                            value: "applicants/applicant.maritalStatus",
                            label: "Applicant Marital Status",
                        },
                        {
                            value: "applicants/applicant.numberOfDependants",
                            label: "Applicant Number of Dependants",
                        },
                        {
                            value: "applicants/applicant.applicantType",
                            label: "Applicant Type",
                        },
                        {
                            value: "applicants/applicant.hasInvestmentProperty",
                            label: "Applicant Has Investment Property",
                        },
                        {
                            value: "applicants/applicant.marketingOptout",
                            label: "Marketing Opt Out",
                        },

                        {
                            value: "applicants/applicant.cashAtBank",
                            label: "Cash at Bank",
                        },
                        {
                            value: "applicants/applicant.mortgagedProperties",
                            label: "Number of Mortgaged Properties",
                        },
                        {
                            value: "applicants/applicant.mortgagedAssetValue",
                            label: "Total Asset Value Of Mortgaged Properties",
                        },
                        {
                            value: "applicants/applicant.mortgagedBalance",
                            label: "Total Balance On All Mortgaged Properties",
                        },
                        {
                            value: "applicants/applicant.ownedOutrightProperties",
                            label: "Number of Owned Outright Properties",
                        },
                        {
                            value: "applicants/applicant.ownedOutrightAssetValue",
                            label: "Total Asset Value Of Owned Outright Properties",
                        },
                        {
                            value: "applicants/applicant.address.mortgage.lender",
                            label: "Current Mortgage Lender",
                        },
                        {
                            value: "applicants/applicant.address.mortgage.balance",
                            label: "Current Mortgage Balance",
                        },
                        {
                            value: "applicants/applicant.creditScore.comprehensive",
                            label: "Credit Check Comprehensive Credit Score",
                        },
                        {
                            value: "applicants/applicant.creditScore.negative2_0",
                            label: "Credit Check Negative 2.0 Credit Score",
                        },
                        {
                            value: "applicants/applicant.creditScore.negative1_1",
                            label: "Credit Check Negative 1.1 Credit Score",
                        },
                        {
                            value: "applicants/applicant.creditScore.onescore",
                            label: "Credit Check Onescore Credit Score",
                        },
                        {
                            value: "applicants/applicant.customerProvidedCreditScore.status",
                            label: "Customer Provided Credit Status",
                        },
                        {
                            value: "applicants/applicant.customerProvidedCreditScore.score",
                            label: "Customer Provided Credit Score",
                        },
                        {
                            value: "applicants/applicant.customerProvidedCreditScore.scoreType",
                            label: "Customer Provided Credit Score Type",
                        },
                        {
                            value: "applicants/applicant.employment.type",
                            label: "Employment Status",
                        },
                        {
                            value: "applicants/applicant.employment.income.grossYearly",
                            label: "Employment Gross Yearly Income",
                        },
                        {
                            value: "applicants/applicant.monthlyNetIncome",
                            label: "Total Monthly Income",
                        },
                        {
                            value: "applicants/applicant.creditCards",
                            label: "Applicant Credit Cards Total",
                        },
                        {
                            value: "applicants/applicant.creditCardsBalance",
                            label: "Applicant Credit Cards Total Balance",
                        },
                        {
                            value: "applicants/applicant.creditCardsLimit",
                            label: "Applicant Credit Cards Total Limit",
                        },
                        {
                            value: "applicants/applicant.totalSecuredMortgagedVehicleLoans",
                            label: "Total Secured Mortgaged Vehicle Loans",
                        },
                        {
                            value: "applicants/applicant.balanceSecuredMortgagedVehicleLoans",
                            label: "Balance Secured Mortgaged Vehicle Loans",
                        },
                    ],
                },
                {
                    key: "asset_data",
                    label: "Asset",
                    options: [
                        {
                            value: "asset/asset.class",
                            label: "Asset Class",
                        },
                        {
                            value: "asset/asset.typeLabel",
                            label: "Asset Type",
                        },
                        {
                            value: "asset/asset.category",
                            label: "Asset Category",
                        },
                        {
                            value: "asset/asset.subCategory",
                            label: "Asset Sub Category",
                        },
                        {
                            value: "asset/asset.make",
                            label: "Asset Make",
                        },
                        {
                            value: "asset/asset.model",
                            label: "Asset Model",
                        },
                        {
                            value: "asset/asset.odometer",
                            label: "Asset Odometer",
                        },
                        {
                            value: "asset/asset.rego",
                            label: "Asset Rego",
                        },
                        {
                            value: "asset/asset.expectedDate",
                            label: "Asset Expected Delivery Date",
                        },
                        {
                            value: "asset/asset.variant",
                            label: "Asset Variant",
                        },
                        {
                            value: "asset/asset.subVariant",
                            label: "Asset Sub Variant",
                        },
                        {
                            value: "asset/asset.year",
                            label: "Asset Year",
                        },
                        {
                            value: "asset/asset.nvic",
                            label: "Asset NVIC",
                        },
                        {
                            value: "asset/asset.assetCost",
                            label: "Asset Cost",
                        },
                        {
                            value: "asset/asset.valuation",
                            label: "Asset Valuation",
                        },
                        {
                            value: "asset/asset.deposit",
                            label: "Asset Deposit",
                        },
                        {
                            value: "asset/asset.tradeIn.value",
                            label: "Asset Trade",
                        },
                        {
                            value: "asset/asset.tradeIn.payoutAmount",
                            label: "Asset Payout",
                        },
                        {
                            value: "asset/asset.balloonAmount",
                            label: "Asset Balloon",
                        },
                    ],
                },
                {
                    key: "broker_data",
                    label: "Broker",
                    options: [
                        {
                            value: "broker/broker.name",
                            label: "Broker Name",
                        },
                        {
                            value: "broker/broker.email",
                            label: "Broker Email",
                        },
                    ],
                },
                {
                    key: "seller_data",
                    label: "Seller",
                    options: [
                        {
                            value: "seller/asset.seller.type.name",
                            label: "Seller Type",
                        },
                        {
                            value: "seller/asset.seller.contact.fullName",
                            label: "Seller Name",
                        },
                        {
                            value: "seller/asset.seller.contact.email",
                            label: "Seller Email",
                        },
                        {
                            value: "seller/asset.seller.contact.phone",
                            label: "Seller Phone",
                        },
                    ],
                },
                {
                    key: "dealership_data",
                    label: "Dealership",
                    options: [
                        {
                            value: "seller/asset.seller.dealership.name",
                            label: "Dealership Name",
                        },
                    ],
                },
                {
                    key: "referrer_data",
                    label: "Referrer",
                    options: [
                        {
                            value: "referrer/referrer.name",
                            label: "Referrer Business Name",
                        },
                        {
                            value: "referrer/referrer.contact.name",
                            label: "Referrer Contact Name",
                        },
                        {
                            value: "referrer/referrer.fee",
                            label: "Referrer Fee",
                        },
                    ],
                },
                {
                    key: "lender_data",
                    label: "Lender",
                    options: [
                        {
                            value: "lender/loan.lender.name",
                            label: "Lender Name",
                        },
                        {
                            value: "lender/loan.lender.phone",
                            label: "Lender Phone",
                        },
                        {
                            value: "lender/loan.lender.email",
                            label: "Lender Email",
                        },
                        {
                            value: "lender/loan.lender.abn",
                            label: "Lender ABN",
                        },
                        {
                            value: "lender/loan.submission.applicationId",
                            label: "Lender Application Id",
                        },
                        {
                            value: "lender/loan.submission.contractNumber",
                            label: "Lender Contract Number",
                        },
                    ],
                },
                {
                    key: "insurance_data",
                    label: "Insurance Dimensions",
                    options: [
                        {
                            value: "inusrance/insurances.comprehensive.provider",
                            label: "Comp Provider",
                        },
                        {
                            value: "inusrance/insurances.comprehensive.name",
                            label: "Comp Product",
                        },
                        {
                            value: "inusrance/insurances.comprehensive.frequency",
                            label: "Comp Frequency",
                        },
                        {
                            value: "inusrance/insurances.comprehensive.policyNumber",
                            label: "Comp Policy Number",
                        },
                        {
                            value: "inusrance/insurances.gap.provider",
                            label: "Gap Provider",
                        },
                        {
                            value: "inusrance/insurances.gap.name",
                            label: "Gap Product",
                        },
                        {
                            value: "inusrance/insurances.gap.termInMonths",
                            label: "Gap Term",
                        },
                        {
                            value: "inusrance/insurances.gap.policyNumber",
                            label: "Gap Policy Number",
                        },
                        {
                            value: "inusrance/insurances.warranty.provider",
                            label: "Wty Provider",
                        },
                        {
                            value: "inusrance/insurances.warranty.name",
                            label: "Wty Product",
                        },
                        {
                            value: "inusrance/insurances.warranty.termInMonths",
                            label: "Wty Term",
                        },
                        {
                            value: "inusrance/insurances.warranty.policyNumber",
                            label: "Wty Policy Number",
                        },
                        {
                            value: "inusrance/insurances.cci.provider",
                            label: "Cci Provider",
                        },
                        {
                            value: "inusrance/insurances.cci.name",
                            label: "Cci Product",
                        },
                        {
                            value: "inusrance/insurances.cci.termInMonths",
                            label: "Cci Term",
                        },
                        {
                            value: "inusrance/insurances.cci.policyNumber",
                            label: "Cci Policy Number",
                        },
                        {
                            value: "inusrance/insurances.comprehensive.commission",
                            label: "Comp Commission",
                        },
                        {
                            value: "inusrance/insurances.gap.premium",
                            label: "Gap Premium",
                        },
                        {
                            value: "inusrance/insurances.gap.commission",
                            label: "Gap Commission",
                        },
                        {
                            value: "inusrance/insurances.warranty.premium",
                            label: "Wty Premium",
                        },
                        {
                            value: "inusrance/insurances.warranty.commission",
                            label: "Wty Commission",
                        },
                        {
                            value: "inusrance/insurances.cci.premium",
                            label: "Cci Premium",
                        },
                        {
                            value: "inusrance/insurances.cci.commission",
                            label: "Cci Commission",
                        },
                    ],
                },
            ],
        }
    },
    mounted() {
        this.setZapData(true)
        this.$store.dispatch("user/saveUser", this.$store.getters.token)
    },
    watch: {
        // "zapForm.endpoint": {
        //     handler(endpoint) {
        //         if (endpoint && typeof endpoint !== "undefined") {
        //             let zapierEndpoint = "https://hooks.zapier.com/"
        //             let zapierEndpointSize = _.size(zapierEndpoint)
        //             let endpointSize = _.size(endpoint)

        //             if (endpointSize > zapierEndpointSize) {
        //                 let endpointUrl = endpoint.slice(0, zapierEndpointSize)
        //                 if (endpointUrl != zapierEndpoint) {
        //                     this.zapForm.endpoint = null
        //                 }
        //             } else {
        //                 let match = zapierEndpoint.slice(0, endpointSize)
        //                 if (endpointSize <= zapierEndpointSize) {
        //                     if (endpoint != match) {
        //                         this.zapForm.endpoint = null
        //                     }
        //                 }
        //             }
        //         }
        //     },
        //     immediate: true,
        // },
        search: {
            handler() {
                if (this.searchTimeout) clearTimeout(this.searchTimeout)
                this.searchTimeout = setTimeout(() => {
                    this.setZapData(true)
                }, this.searchTimeoutWait)
            },
        },
    },
    methods: {
        setCustomFields() {
            if (!_.isEmpty(this.customFields)) {
                this.customFields.forEach(customField => {
                    let options = Object.entries(customField.keys).map(key => {
                        return {
                            value: `customFields/form_custom_fields.cf_${customField.uuid}_${key[0]}`,
                            label: key[1]
                        }
                    })
                    let customFieldMarkup = {
                        key: `${_.snakeCase(customField.name)}_data`,
                        label: `${customField.name} Custom Fields`,
                        options: options
                    }

                    console.warn('options', options)
                    this.zapOptions.push(customFieldMarkup)
                })
            }
        },
        changeSelect(selected) {
            let selectAllKeys = ["application_data", "applicant_data", "asset_data", "lender_data", "insurance_data"]

            selected.forEach((key) => {
                if (selectAllKeys.includes(key)) {
                    let selectedOptions = this.zapOptions.find((option) => option.key == key).options
                    selectedOptions.forEach((selected) => {
                        let selectedIndex = this.zapForm.fields.findIndex((field) => field == selected.value)
                        if (selectedIndex === -1) {
                            this.zapForm.fields.push(selected.value)
                        }
                        let selectAllIndex = this.zapForm.fields.findIndex((field) => field == key)
                        Vue.delete(this.zapForm.fields, selectAllIndex)
                    })
                }
            })
        },
        setZapData(resetPage) {
            if (resetPage) {
                this.zaps.current_page = 1
            }
            let data = {
                zaps: this.zaps,
                search: this.search,
                team_id: _.get(window.TenantGlobals, 'currentTeamId')
            }
            this.tableLoading = true
            this.$store.dispatch("zapier/setZaps", data).then((res) => {
                this.tableLoading = false
                this.setCustomFields()
            })
        },
        // set row keys
        setRowKeys(row) {
            return row.id
        },
        // format date
        dateFormatter(row) {
            let updated = this.$moment.utc(row.updated_at).tz(this.user.timezone)
            if (updated) {
                return this.$moment.utc(row.updated_at).tz(this.user.timezone).format("ddd DD/MM/YY LT")
            }
        },
        triggerFormatter(triggers) {
            let stageTriggers = _.flatten(
                this.statusList.map((list) =>
                    list.options.filter((status) => triggers.find((trigger) => trigger.triggerKey == status.value))
                )
            )
            if (stageTriggers) {
                return stageTriggers
                    .map(function (trigger) {
                        return trigger.label
                    })
                    .join(", ")
            }
        },
        setActiveState(row) {
            this.activeClicked = true
            let data = {
                form: {
                    id: row.id,
                    state: !row.active,
                },
                user: this.user,
            }

            this.$store.dispatch("zapier/setZapActiveState", data).then((res) => {
                this.activeClicked = false
                swal({
                    title: "Success!",
                    type: "success",
                    text: row.name + " Ambition Zap is now " + (!row.active ? "Active" : "Disabled"),
                })
            })
        },
        openZapModal(row) {
            this.create = true
            this.zapForm = {
                active: 0,
                repeat: 0,
                team_id: _.get(window.TenantGlobals, 'currentTeamId')
            }
            if (row) {
                this.create = false
                let editData = Object.assign({}, row)
                this.zapForm = editData
                this.zapForm.team_id = _.get(window.TenantGlobals, 'currentTeamId')
                this.zapForm.fields = editData.fields.map((field) => field.value)
                this.zapForm.triggers = editData.triggers.map((trigger) => trigger.triggerKey)
            }

            // bug fix
            setTimeout(() => {
                this.$refs["zapForm"].clearValidate()
            }, 1)

            this.visible = true
            this.loading = false
        },
        deleteZap(row) {
            this.deleteClicked = true
            let data = {
                id: row.id,
                user: this.user,
            }
            swal({
                title: "Delete, are you sure?",
                text: `Are you sure you want to delete this ${row.name} Ambition Zap.`,
                type: "warning",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                cancelButtonColor: "#d33",
                confirmButtonText: "Delete",
                confirmButtonColor: "#284da5",
                reverseButtons: false,
            }).then((actioned) => {
                if (actioned.value) {
                    this.$store.dispatch("zapier/deleteZap", data).then((res) => {
                        this.deleteClicked = false
                        swal({
                            title: "Success!",
                            type: "success",
                            text: row.name + " Ambition Zap was Deleted",
                        })
                    })
                } else {
                    this.deleteClicked = false
                }
            })
        },
        saveZap(zap) {
            this.$refs["zapForm"].validate((valid) => {
                if (valid) {
                    this.loading = true
                    let action = this.create ? "createZap" : "updateZap"
                    let data = {
                        form: this.zapForm,
                        user: this.user,
                        testZap: zap,
                    }

                    this.$store.dispatch("zapier/" + action, data).then((res) => {
                        this.loading = false
                        if (this.create) {
                            swal({
                                title: "Zap Created",
                                type: "success",
                                text: "Your Zap was successfully created and a test zap was sent to the webhook url. Continue to map the fields on Zapier to your desired endpoint then active the zap both on Zapier and here.",
                            })
                        } else {
                            swal({
                                title: "Zap Updated",
                                type: "success",
                                text:
                                    "Your Zap was successfully updated" +
                                    (zap ? " and a Ambition Test Zap was sent to Zapier" : ""),
                            })
                        }
                        this.visible = false
                        this.loading = false
                    })
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
small {
    width: 100%;
    display: table;
    line-height: 20px;
    margin-bottom: 10px;
}

.section-table {
    background-color: #f0f3f5;
    border: 1px solid #c2cfd6;
    padding: 10px;

    .pagination-container {
        border: 1px solid #dcdfe6;
        border-radius: 5px;
        padding: 10px !important;

        &.pagination-top {
            margin-bottom: 10px !important;
        }

        &.pagination-bottom {
            margin-top: 10px !important;
            margin-bottom: 0 !important;
        }

        .el-pager {
            li {
                background-color: transparent;
                border: 1px solid #dcdfe6;
                font-weight: 400;

                &.active {
                    background-color: #69c23a;
                    border: none;
                }
            }
        }
    }

    .el-table {
        border: 1px solid #dcdfe6;
        border-radius: 5px;

        .cell {
            word-break: break-word;
        }
    }
}

.el-form-item__label {
    width: 100%;
    text-align: left;
}

.el-transfer:deep {
    .el-transfer-panel {
        width: 100%;

        .el-checkbox {
            &.is-disabled {
                .el-checkbox__input {
                    display: none;
                }

                .el-checkbox__label {
                    color: #f4801f;
                    font-weight: 700;
                    font-size: 18px;
                }
            }
        }
    }
}

.el-transfer:deep .el-transfer__buttons {
    padding: 20px 0;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    flex-flow: row-reverse;

    .el-button {
        margin: 0 10px 0 0;

        .el-icon-arrow-left,
        .el-icon-arrow-right {
            transform: rotate(90deg);
        }
    }
}
</style>
